import { Component, Inject, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoggingService } from 'src/app/core/services/logging.service';

@Component({
  selector: 'app-profile-view',
  templateUrl: './profile-view.component.html',
  styleUrls: ['./profile-view.component.scss'],
  standalone: false
})
export class ProfileViewComponent implements OnInit {
  profileData: {
    adminRoles?: Array<string>;
    email?: string;
    isActive?: boolean;
    userName?: string;
  } = {};
  private readonly logger = inject(LoggingService);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      adminRoles?: Array<string>;
      email?: string;
      isActive?: boolean;
      userName?: string;
    },
    private readonly router: Router
  ) {
    this.profileData = this.data;
  }

  ngOnInit(): void {}

  backToHome() {
    this.router
      .navigate(['/dashboard'])
      .catch((e) => this.logger.log('Log', e));
  }
}
